import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="Home" mdxType="Seo" />
    <h1 {...{
      "id": "gatsby-starter-catalyst"
    }}>{`Gatsby Starter Catalyst`}</h1>
    <p>{`Basic starter that could be used as a barebones starting point for building a finished website. Implements `}<inlineCode parentName="p">{`gatsby-theme-catalyst-core`}</inlineCode>{`, `}<inlineCode parentName="p">{`gatsby-theme-catalyst-header-top`}</inlineCode>{`, and `}<inlineCode parentName="p">{`gatsby-theme-catalyst-footer`}</inlineCode>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/ehowey/gatsby-theme-catalyst",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`Read the docs on Github`}</a></p>
    <h2 {...{
      "id": "about-gatsby-theme-catalyst"
    }}>{`About Gatsby Theme Catalyst`}</h2>
    <p>{`The Catalyst series of themes and starters for `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.com/",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`GatsbyJS`}</a>{` were designed to provide an opinionated set of integrated themes and starters that can be used to accelerate your next Gatsby project. The vision is for one “core” theme in which most dependencies and components are contained followed by progressively more styled and refined child themes and starters. These themes rely heavily on `}<a parentName="p" {...{
        "href": "https://theme-ui.com/",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`Theme-UI`}</a>{` and `}<a parentName="p" {...{
        "href": "https://mdxjs.com/getting-started/gatsby/",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`MDX`}</a>{`.`}</p>
    <h2 {...{
      "id": "markdown-tests"
    }}>{`Markdown Tests`}</h2>
    <p>{`The following section provides some formatting tests the themes and starters. If you are changing styles using Theme-UI you should be able to quickly see changes on this page. Most common markdown elements are included and at the end there is an example blog post to test.`}</p>
    <h3 {...{
      "id": "headers"
    }}>{`Headers`}</h3>
    <h1 {...{
      "id": "h1"
    }}>{`H1`}</h1>
    <h2 {...{
      "id": "h2"
    }}>{`H2`}</h2>
    <h3 {...{
      "id": "h3"
    }}>{`H3`}</h3>
    <h4 {...{
      "id": "h4"
    }}>{`H4`}</h4>
    <h5 {...{
      "id": "h5"
    }}>{`H5`}</h5>
    <h6 {...{
      "id": "h6"
    }}>{`H6`}</h6>
    <h3 {...{
      "id": "code"
    }}>{`Code`}</h3>
    <p>{`Pre-formatted code blocks are used for writing about programming or
markup source code. Rather than forming normal paragraphs, the lines
of a code block are interpreted literally. Markdown wraps a code block
in both `}<inlineCode parentName="p">{`<pre>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<code>`}</inlineCode>{` tags.`}</p>
    <p>{`To indicate a span of code, wrap it with backtick quotes (`}<inlineCode parentName="p">{`\``}</inlineCode>{`).
Unlike a pre-formatted code block, a `}<inlineCode parentName="p">{`code span`}</inlineCode>{` indicates code within a
normal paragraph.`}</p>
    <pre><code parentName="pre" {...{}}>{`This is a simple code block.
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`//This is a jsx code block.
import awesome from "radical"

const Super = () => {
  return (
    <div>
      <h1>Super Awesome</h1>
    </div>
  )
}

export default Super
`}</code></pre>
    <h3 {...{
      "id": "embeds"
    }}>{`Embeds`}</h3>
    <p>{`MDX embeds powered by `}<a parentName="p" {...{
        "href": "https://gatsby-mdx-embed.netlify.app/",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`gatsby-mdx-embed`}</a>{`. Support for automatically including Twitter, Youtube, Instagram and other social media directly in your markdown.`}</p>
    <h3 {...{
      "id": "blockquotes"
    }}>{`Blockquotes`}</h3>
    <blockquote>
      <p parentName="blockquote">{`This is a blockquote with two paragraphs. Lorem ipsum dolor sit amet,
consectetuer adipiscing elit. Aliquam hendrerit mi posuere lectus.
Vestibulum enim wisi, viverra nec, fringilla in, laoreet vitae, risus.`}</p>
      <p parentName="blockquote">{`Donec sit amet nisl. Aliquam semper ipsum sit amet velit. Suspendisse
id sem consectetuer libero luctus adipiscing.`}</p>
    </blockquote>
    <h3 {...{
      "id": "links"
    }}>{`Links`}</h3>
    <p>{`This is `}<a parentName="p" {...{
        "href": "https://www.erichowey.dev",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`an example`}</a>{` link.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.erichowey.dev",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`This link`}</a>{` has no title attribute and is in a longer set of words. Let’s see how long I can type before I get bored and stop typing. Here is me filling in some more spaces. And wow we have `}<a parentName="p" {...{
        "href": "https://www.erichowey.dev",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`encountered another link`}</a>{` in the wild!`}</p>
    <h3 {...{
      "id": "images"
    }}>{`Images`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1440px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "66.66666666666666%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABgAH/8QAFwEAAwEAAAAAAAAAAAAAAAAAAQMFBv/aAAwDAQACEAMQAAAB0UOab5yu9sCkj//EABoQAAMBAQEBAAAAAAAAAAAAAAMEBQIBBhP/2gAIAQEAAQUC6fa7JA6FVk1volinsbR6XMzkvQlQ5//EABoRAAICAwAAAAAAAAAAAAAAAAEDAAIRIjH/2gAIAQMBAT8BWirNxCK55P/EAB8RAAIBAgcAAAAAAAAAAAAAAAIDABHRAQQSISNhof/aAAgBAgEBPwF+ZakTHTvTq8FLaYcheWn/xAAhEAACAQMFAAMAAAAAAAAAAAABAgMABBETISIxQRIyUf/aAAgBAQAGPwJ557YRlmMSS6xOU892qUz2/wArW4LpqxnrbHKkFviSJOHfWPDVpbOolRlH283pToKRq4xUyRRIEMjMB+V//8QAHBAAAgIDAQEAAAAAAAAAAAAAAREAITFBYVGh/9oACAEBAAE/IV0JEOAoSr0y+PP1rcM68gLyAUeKy3M9BfwoYh8Z6mmQ38iyh1318n//2gAMAwEAAgADAAAAEBjP/8QAGxEBAAICAwAAAAAAAAAAAAAAAQARIUFhodH/2gAIAQMBAT8QKKEves8kAhPfs//EABoRAQACAwEAAAAAAAAAAAAAAAEAMSFBgfH/2gAIAQIBAT8QHLKOPWY1ijbL/8QAHBABAAIDAAMAAAAAAAAAAAAAAREhADFBYXGh/9oACAEBAAE/ELVBbR2mSCUkm7xlfbwyiuQlhFovRAZhydhKB83CYyAYUQtPpTruGO7l2Q57n6cglfOAQRQsNFuK5n//2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/2021/static/5e8f9172631db490aa646bc3c66c9ffe/e1989/image1.webp 360w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/aced9/image1.webp 720w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/fead5/image1.webp 1440w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/8fb31/image1.webp 1800w"],
            "sizes": "(max-width: 1440px) 100vw, 1440px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/2021/static/5e8f9172631db490aa646bc3c66c9ffe/1ff7f/image1.jpg 360w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/554bf/image1.jpg 720w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/60e21/image1.jpg 1440w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/96503/image1.jpg 1800w"],
            "sizes": "(max-width: 1440px) 100vw, 1440px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/60e21/image1.jpg",
            "alt": "Alt Image Text 1",
            "title": "Alt Image Text 1",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "tables"
    }}>{`Tables`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Heading`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Another Heading`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`More Heading`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Something`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`124891`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Default is volcanoes.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Strange`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1098731`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Some longer text to test how it looks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Is`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1874`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Oranges are better than apples.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Happening`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`912641969`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To the moon and back.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "lists"
    }}>{`Lists`}</h3>
    <p>{`Markdown supports ordered (numbered) and unordered (bulleted) lists.`}</p>
    <p>{`Unordered lists use asterisks, pluses, and hyphens — interchangably
— as list markers:`}</p>
    <ul>
      <li parentName="ul">{`Red`}</li>
      <li parentName="ul">{`Green`}</li>
      <li parentName="ul">{`Blue`}</li>
    </ul>
    <p>{`Ordered lists use numbers followed by periods:`}</p>
    <ol>
      <li parentName="ol">{`Bird`}</li>
      <li parentName="ol">{`McHale`}</li>
      <li parentName="ol">{`Parish`}</li>
    </ol>
    <h3 {...{
      "id": "emphasis"
    }}>{`Emphasis`}</h3>
    <p><em parentName="p">{`single underscores`}</em></p>
    <p><em parentName="p">{`Some more text in italics to get a better feel for how it can look. Here it goes just continuing on.`}</em></p>
    <p><strong parentName="p">{`double asterisks`}</strong></p>
    <p><strong parentName="p">{`Some more BOLD text. This really draws attention to it and helps to give a feel for what it looks like just a bit longer.`}</strong></p>
    <h3 {...{
      "id": "anchor-1"
    }}>{`Anchor 1`}</h3>
    <p>{`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed luctus
vestibulum aliquam. Duis sapien est, elementum sed ultrices nec, pharetra et
magna. Pellentesque quis nulla et neque fringilla ornare eget mollis nisi.
Aliquam erat volutpat. Donec tempus porttitor mi, ut semper urna posuere
nec. In in turpis in dui consequat viverra.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1440px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "66.66666666666666%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABgAH/8QAFwEAAwEAAAAAAAAAAAAAAAAAAQMFBv/aAAwDAQACEAMQAAAB0UOab5yu9sCkj//EABoQAAMBAQEBAAAAAAAAAAAAAAMEBQIBBhP/2gAIAQEAAQUC6fa7JA6FVk1volinsbR6XMzkvQlQ5//EABoRAAICAwAAAAAAAAAAAAAAAAEDAAIRIjH/2gAIAQMBAT8BWirNxCK55P/EAB8RAAIBAgcAAAAAAAAAAAAAAAIDABHRAQQSISNhof/aAAgBAgEBPwF+ZakTHTvTq8FLaYcheWn/xAAhEAACAQMFAAMAAAAAAAAAAAABAgMABBETISIxQRIyUf/aAAgBAQAGPwJ557YRlmMSS6xOU892qUz2/wArW4LpqxnrbHKkFviSJOHfWPDVpbOolRlH283pToKRq4xUyRRIEMjMB+V//8QAHBAAAgIDAQEAAAAAAAAAAAAAAREAITFBYVGh/9oACAEBAAE/IV0JEOAoSr0y+PP1rcM68gLyAUeKy3M9BfwoYh8Z6mmQ38iyh1318n//2gAMAwEAAgADAAAAEBjP/8QAGxEBAAICAwAAAAAAAAAAAAAAAQARIUFhodH/2gAIAQMBAT8QKKEves8kAhPfs//EABoRAQACAwEAAAAAAAAAAAAAAAEAMSFBgfH/2gAIAQIBAT8QHLKOPWY1ijbL/8QAHBABAAIDAAMAAAAAAAAAAAAAAREhADFBYXGh/9oACAEBAAE/ELVBbR2mSCUkm7xlfbwyiuQlhFovRAZhydhKB83CYyAYUQtPpTruGO7l2Q57n6cglfOAQRQsNFuK5n//2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/2021/static/5e8f9172631db490aa646bc3c66c9ffe/e1989/image1.webp 360w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/aced9/image1.webp 720w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/fead5/image1.webp 1440w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/8fb31/image1.webp 1800w"],
            "sizes": "(max-width: 1440px) 100vw, 1440px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/2021/static/5e8f9172631db490aa646bc3c66c9ffe/1ff7f/image1.jpg 360w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/554bf/image1.jpg 720w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/60e21/image1.jpg 1440w", "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/96503/image1.jpg 1800w"],
            "sizes": "(max-width: 1440px) 100vw, 1440px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/2021/static/5e8f9172631db490aa646bc3c66c9ffe/60e21/image1.jpg",
            "alt": "Alt Image Text 1",
            "title": "Alt Image Text 1",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`In dictum rutrum purus, aliquet dapibus ante. Nullam non felis at ex consectetur laoreet vitae eu dui. Curabitur orci massa, tincidunt quis elementum a, maximus non erat. Curabitur semper turpis a nibh hendrerit porttitor. Morbi accumsan iaculis orci in molestie. Donec at elementum nisl. Phasellus tellus nulla, dapibus vitae gravida sed, euismod eget urna.`}</p>
    <p>{`Cras at odio bibendum leo dictum porta. Curabitur mattis elementum neque id tristique. Nam laoreet sed quam bibendum viverra. Aenean sit amet `}<a parentName="p" {...{
        "href": "https://www.google.com",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`suscipit`}</a>{` sem. Mauris convallis ex non nibh interdum pulvinar. Suspendisse potenti. Vivamus odio velit, luctus non interdum at, interdum nec tellus. Fusce non consequat erat, in vestibulum ligula. Praesent eu lacus non mi accumsan faucibus.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Here is an amazing block quote. Transcendent information that will inspire some amazing life changes for you.`}</p>
    </blockquote>
    <p>{`Nullam sit amet magna leo. Suspendisse scelerisque pellentesque gravida. Nullam congue rhoncus tellus dapibus aliquam. Ut in risus odio. Ut vel odio laoreet, elementum ipsum id, elementum elit. Nunc convallis ex mi, at laoreet sem mattis eu. `}<a parentName="p" {...{
        "href": "https://www.google.com",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`Aenean tempor tincidunt`}</a>{` hendrerit. Proin nec sem mollis, viverra ligula a, sodales dolor. Nullam mauris massa, cursus pulvinar pretium sed, placerat ut nisl. Nunc congue porta augue vitae feugiat. Quisque placerat libero at lectus dictum, at mattis nisi consequat. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aliquam erat volutpat.`}</p>
    <p><strong parentName="p">{`Interesting Sub-heading`}</strong></p>
    <p>{`Sed maximus urna malesuada, tempor sem semper, iaculis orci. Vestibulum augue risus, cursus volutpat orci sed, rutrum efficitur eros. Praesent vel orci id ex venenatis egestas. Morbi ac venenatis nulla. Vivamus lobortis volutpat lacus sed consequat. Aliquam in porta purus. Vestibulum scelerisque lobortis nibh sed lobortis.`}</p>
    <p>{`Phasellus fermentum vestibulum nibh, a volutpat est sollicitudin ut. Proin eget justo viverra, mattis tortor at, sodales quam. Donec lacinia, diam ut iaculis varius, nibh ante pharetra turpis, quis tristique odio arcu convallis leo. Donec varius tellus ac fringilla rhoncus. Quisque vitae tristique turpis. Integer blandit lacinia neque at egestas. Maecenas ultrices nisi bibendum hendrerit blandit. Donec vitae libero quis tortor luctus porttitor non at nulla. Nam eget est ac mi ullamcorper pellentesque sit amet ac eros.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`//This is a jsx code block.
import awesome from "radical"

const Super = () => {
  return (
    <div>
      <h1>Super Awesome</h1>
    </div>
  )
}

export default Super
`}</code></pre>
    <p>{`Quisque at ornare massa, nec accumsan justo. Praesent auctor at ipsum vitae sodales. Cras quis posuere lorem. Cras sed vehicula nisl. Aliquam accumsan posuere nulla eget tristique.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      